<template>
  <div class="weapon-selector">
    <div class="weapon-label">Weapon</div>
    <div class="weapons-list">
      <div 
        v-for="weapon in availableWeapons" 
        :key="weapon"
        :class="['weapon-item', { active: weapon === currentWeapon }]"
        @click="selectWeapon(weapon)"
      >
        {{ weapon }}
        <span class="key-hint">{{ getKeyHint(weapon) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeaponSelector',
  props: {
    currentWeapon: {
      type: String,
      required: true
    },
    availableWeapons: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    selectWeapon(weapon) {
      this.$emit('weapon-selected', weapon);
    },
    getKeyHint(weapon) {
      const weaponIndex = this.availableWeapons.indexOf(weapon);
      if (weaponIndex >= 0 && weaponIndex < 9) {
        return weaponIndex + 1; // Keys 1-9 for weapon selection
      }
      return '';
    }
  }
};
</script>

<style scoped>
.weapon-selector {
  display: flex;
  flex-direction: column;
  padding: 5px 15px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  min-width: 120px;
}

.weapon-label {
  font-weight: bold;
  margin-bottom: 5px;
}

.weapons-list {
  display: flex;
  gap: 10px;
}

.weapon-item {
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s ease;
  pointer-events: auto;
}

.weapon-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.weapon-item.active {
  background-color: rgba(255, 255, 255, 0.3);
  font-weight: bold;
}

.key-hint {
  position: absolute;
  top: -8px;
  right: -5px;
  font-size: 0.7em;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 3px;
  padding: 1px 4px;
  opacity: 0.7;
}
</style> 